// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"az_ugb","container":"az_vgb","componentContainer":"az_wgb","splitContent":"az_xgb","imageContainer":"az_ygb"};